// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import utils from 'inomph-common'
import moment from 'moment'
import Snackbar from 'node-snackbar'
import router from './router'
import store from './store'
import VueMeta from 'vue-meta'
import VueLogger from 'vuejs-logger'
import axios from 'axios'
import VeeValidate from 'vee-validate'
import Datepicker from 'vuejs-datepicker'
import VueTheMask from 'vue-the-mask'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

require('materialize-css')
require('materialize-css/dist/css/materialize.min.css')
require('node-snackbar/dist/snackbar.min.css')
require('grapesjs-preset-newsletter')
require('grapesjs-preset-newsletter/dist/grapesjs-preset-newsletter.min.js')

Vue.config.productionTip = false
Object.defineProperty(Vue.prototype, '$moment', {value: moment})
Object.defineProperty(Vue.prototype, '$utils', { value: utils })
Object.defineProperty(Vue.prototype, '$snackbar', {value: Snackbar})
Object.defineProperty(Vue.prototype, '$config', {value: process.env})
Object.defineProperty(Vue.prototype, '$http', {value: axios})
/* eslint-disable no-undef, no-undef */

Object.defineProperty(Vue.prototype, '$M', {value: M})

Vue.use(VueMeta, {
  keyName: 'meta'
})

Vue.use(VeeValidate)
Vue.use(Datepicker)
Vue.use(VueTheMask)
Vue.use(Vuetify)

Vue.use(VueLogger, {
  isEnabled: process.env !== 'production',
  logLevel: 'debug',
  stringifyArguments: false,
  showLogLevel: false,
  showMethodName: true,
  separator: '|',
  showConsoleColors: false
})

Snackbar.error = function (errorMessage) {
  this.show({
    text: errorMessage,
    actionText: 'okay',
    pos: 'bottom-right',
    showAction: true,
    textColor: '#FFF',
    actionTextColor: '#d3d3d3',
    backgroundColor: '#B03236',
    customClass: 'fast',
    duration: 5000
  })
}

Snackbar.success = function (successMessage) {
  this.show({
    text: successMessage,
    pos: 'top-right',
    showAction: false,
    textColor: '#FFF',
    backgroundColor: '#039403',
    customClass: 'fast',
    duration: 2000
  })
}

/* eslint-disable no-new */
const root = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  store: store
})

store.commit('modal/setVue', Vue)
store.commit('modal/setParent', root)



// WEBPACK FOOTER //
// ./src/main.js